import React from "react";
import "./GrupoFamiliar.css";

const GrupoFamiliarTxt = () => {
    return (
        <React.Fragment>
            <div className="ptur-grupoFamiliar-textoInicial">
                <p className="rb24b ptur-grupoFamiliar-texto1">Mi grupo familiar</p>
                <p className="rb18l">Seguí los resultados de tu grupo familiar y gestioná sus turnos. </p>
            </div>
        </React.Fragment>
    );
}
 
export default GrupoFamiliarTxt;